import TextComponent from 'Component/Render/Text';
import { ICardsState } from 'State/Card/ICardState';
import { StartAnimationClip, StopAnimation } from 'System/Animation/AnimationHelper';
import { Pulse, PulseLoop } from 'System/Animation/Clip';
import { AudioTrackType } from 'System/Audio/AudioClip';
import { PlaySound } from 'System/Audio/AudioHelper';
import Point from 'Utility/Point';
import CardSystem from '../../CardSystem';
import BaseCardModifierHandler from './BaseCardModifierHandler';

export default class TomatoModifierHandler extends BaseCardModifierHandler {
    public handleModifierInPlay(state: ICardsState, cardSystem: CardSystem) {
        const modifierStateData = this.getModifierStateData(state);
        const currentTimer = modifierStateData.properties.timer;

        if (
            this.modifierComponent.properties.timer !==
            currentTimer
        ) {
            const bombArmature: GameObject = this.modifier.find('tomato_bomb_armature');

            const turnCount: GameObject = bombArmature.find('turn_count');
            turnCount.getComponent(TextComponent).text = currentTimer.toString();
                
            const turnCountRed: GameObject = bombArmature.find('turn_count_red');
            const turnCountRedTextComp = turnCountRed.getComponent(TextComponent);
            turnCountRedTextComp.text = currentTimer.toString();

            PlaySound('hazard-bomb-countdown');

            if (currentTimer === 1) {
                StartAnimationClip(
                    new PulseLoop(
                        this.modifier,
                        {
                            duration: 350,
                            scale1: new Point(1, 1),
                            scale2: new Point(1.05, 1.05),
                            interval: 1,
                            delay: 100,
                            text: turnCountRedTextComp,
                        },
                        true
                    )
                );
            } else {
                StopAnimation(this.modifier)
                StartAnimationClip(new Pulse(this.modifier, { repeat: 1 }, true));
            }
        }
    }
}
